// @flow
import { titleToSlug } from '../../../services/titleToSlug'
import { numberToCurrency } from '../../../services/numberToCurrency'
import catalogMedia from './assets/catalog'

export default {
  productID: 'hardCoded.productID.malquerida',
  title: 'hardCoded.title.malquerida',
  format: 'hardCoded.format.item',
  slug: titleToSlug('hardCoded.title.malquerida'),
  catalog: {
    title: 'hardCoded.catalog.title.malquerida',
    catalogMedia,
    price: numberToCurrency('3.42'),
    color: '#52d832'
  }
}
